<template>
    <article class="venueinfo">
        <div class="venueinfo-banner">
            <img src="../assets/imgs/true.jpg" alt="俱乐部说明">
        </div>
        <header class="venueinfo-header bcw">
            <h1>关于预约的说明</h1>
            <div class="c9 fs1 mtn">今天</div>
        </header>
        <div class="venueinfo-content c6 fs3">
            1.用户购买练球卡和私教课可进行预约练球；<br/>
            2.用户登录后，可在“我的预约”选择对应的练球卡预约或私教课预约；<br/>
            3.私教课预约需等待私教教练同意后，即代表预约成功；<br/>
            4.其他预约说明请以俱乐部实际情况为准。<br/>
        </div>
    </article>
</template>
<script>
export default {
    name: 'VenueInfo2',
    data() {
      return {
        clubInfo: {},  
      }
    },
    created() {
    
    }
}
</script>
<style lang="less" scoped>
body{
    background-color: white;
}
.venueinfo{
    position: relative;
    &-header{
        position: absolute;
        top: 1.1rem; left: 5%;
        width: 90%;
        padding: .1rem;
        border: .01rem solid #eee;
        border-radius: .02rem;
        &>h1{
            font-size: .2rem;
        }
    }
    &-content{
        margin: .15rem;
        padding-top: .2rem;
        line-height: 1.6;
        & p{
            text-indent: 2em;
            margin-bottom: .1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VenueInfo2.vue